import { MembershipStatus } from "../generated/api-client";

export const membershipStatusValues: MembershipStatus[] = [
    "Active",
    "Inactive",
    "Left",
    "Departed",
    "Excluded",
];

export const membershipStatusLabels: Partial<Record<MembershipStatus, string>> = {
    Active: "Activo/a",
    Inactive: "Inactivo/a",
    Left: "Se fue",
    Departed: "Fallecido/a",
    Excluded: "Excluido/a",
};

export const membershipStatusOptions = membershipStatusValues.map(value => ({
    value,
    label: membershipStatusLabels[value],
}));
